<template>
  <!-- 20230612 스타일 추가 { -->
  <div
    class="condition"
    style="padding: 0; margin-left: 0; border-radius: 0; border: none"
  >
    <!-- } 20230612 스타일 추가 -->
    <div :class="{ source: true, active: true }">
      <div class="source-content">
        <div class="left">
          <!-- 20230704 추가 { -->
          <!-- <div class="content-box" style="padding: 10px 0; display: flex">
            <p
              style="
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 600;
              "
            >
              <span
                class="material-symbols-outlined"
                style="font-size: 20px; font-weight: 300; margin-right: 5px"
              >
                info
              </span>
              제조사/ATC/제품을 선택하세요.
            </p>
            <div
              v-if="parentMenuCode === constants.CONSTANT_MENU_SOB_CODE"
              style="padding-left: 20px"
            >
              <button class="btn" @click="openMarketModal">
                {{ $t("button.market_definition") }}
              </button>
            </div>
          </div> -->
          <!-- } 20230704 추가 -->

          <div class="search-bar">
            <div class="search-group">
              <input
                style="width: 36.75%"
                :placeholder="$t('label.search_word')"
                v-model="searchTextVal"
                type="text"
                @keydown.enter="fnSearch()"
              />
              <button class="btn" style="margin-left: 5px" @click="fnSearch()">
                {{ $t("button.search") }}
              </button>
              <button
                class="btn"
                style="margin-left: 5px"
                @click="fnSearchClean(showContent.code, showContent.type)"
              >
                {{ $t("button.searchClean") }}
              </button>
            </div>
            <div
              v-if="parentMenuCode === constants.CONSTANT_MENU_SOB_CODE"
              style="position: absolute; right: 20px"
            >
              <button class="btn" @click="openMarketModal">
                {{ $t("button.market_definition") }}
              </button>
            </div>
          </div>
          <div class="patternContents">
            <div style="display: flex">
              <div
                v-for="(groupContent, groupIndex) in contents[
                  patternContentIndex
                ]?.groupContents"
                :key="groupContent.code"
                class="each-group-content-tab"
                :class="{
                  'active-bookmark-tab': activeBookmarkTabIndex === groupIndex,
                }"
                @click="activeBookmarkTabIndex = groupIndex"
              >
                {{
                  $i18n.locale == "en"
                    ? groupContent.englishName != ""
                      ? groupContent.englishName
                      : groupContent.name + "(en)"
                    : groupContent.name
                }}
                ({{ groupContent.count > 0 ? groupContent.count : 0 }})
              </div>
            </div>
          </div>
          <SearchContent v-if="showContent?.list"
            :multiple="true"
            :content="showContent" 
            :searchTextVal="searchTextVal"
            @change="onChange"
            @ondblclick="() => onClick()"
            @enter="() => onClick()"
            @onContextmenu="showContextMenuItem"
          />
          <div v-else class="search-content">
            <div class="search-content">
              <div class="search-content-sub">
                <div class="selected">
                  <div class="header">&nbsp;</div>
                  <select multiple class="select-empty">
                    <option></option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <p
            v-if="
              activeBookmarkTabIndex === 1 &&
              contents[patternContentIndex]?.groupContents[1]?.code ===
                constants.CONSTANT_ATC_234_CODE
            "
            class="content-notice"
          >
            <span>{{ $t("label.step2_atc") }} </span>
          </p>
          <p
            v-else-if="
              (activeBookmarkTabIndex === 0 &&
                contents[patternContentIndex]?.groupContents[0]?.code ===
                  constants.CONSTANT_ATC_4_CODE) ||
              (activeBookmarkTabIndex === 1 &&
                contents[patternContentIndex]?.groupContents[1]?.code ===
                  constants.CONSTANT_ATC_4_CODE)
            "
            class="content-notice"
          >
            <span
              class="material-symbols-outlined"
              style="font-size: 28px; font-weight: 300; margin-right: 5px"
            >
              info
            </span>
            <span>{{ parentMenuCode === constants.CONSTANT_MENU_DIAGNOSIS_1_CODE ? $t("label.step4_atc_diagnosis") : $t("label.step4_atc") }} </span>
          </p>
          <p
            v-else-if="
              (activeBookmarkTabIndex === 1 &&
                constants.CONSTANT_MOLECULE_TAB_CODE.includes(contents[patternContentIndex]?.groupContents[1]?.code)) ||
              (activeBookmarkTabIndex === 2 &&
                constants.CONSTANT_MOLECULE_TAB_CODE.includes(contents[patternContentIndex]?.groupContents[2]?.code))
            "
            class="content-notice"
          >
            <span
              class="material-symbols-outlined"
              style="font-size: 28px; font-weight: 300; margin-right: 5px"
            >
              info </span
            >{{ $t("label.molecule_doses") }}
          </p>
          <p
            v-if="
              parentMenuCode ===
              constants.CONSTANT_MENU_COMBINATION_THERAPY_NEW_CODE
            "
            class="content-notice"
          >
            <span
              class="material-symbols-outlined"
              style="font-size: 28px; font-weight: 300; margin-right: 5px"
            >
              info
            </span>
            <span>{{ $t("label.notice_combination_new_base") }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- 20230622 시장정의 모달 추가 -->
  <div style="z-index: 300">
    <MarketModal
      v-if="parentMenuCode === constants.CONSTANT_MENU_SOB_CODE"
      v-show="isMarketModalOpen"
      v-model:isMarketModalOpen="isMarketModalOpen"
      v-model:code="constants.CONSTANT_MARKET_CODE"
    ></MarketModal>
  </div>

  <AlertDialog
    v-if="isAlertDialogOpen"
    :maxWidthOption="alertDialog.maxWidthOption"
    :title="alertDialog.title"
    :message="alertDialog.message"
    @confirm="closeAlertDialog"
  />
</template>

<script>
import AlertDialog from "@/components/AlertDialog.vue";
import constants from "@/data/constants.js";
import { defineComponent, ref, reactive, watch, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useContentsStore } from "@/store/contents";
import { useCommonStore } from "@/store/common";
import MarketModal from "@/components/MarketModal.vue"; //20230622 시장정의 모달 추가
import channelSpecialtyDoseformData from "@/data/channelSpecialtyDoseformData.js"; //20230622 시장정의 모달 추가
import SearchContent from "@/containerss/SearchContent.vue";

export default defineComponent({
  name: "SimpleTabCondition",
  props: [
    "parentMenu",
    "parentMenuCode",
    "selectedComponentIndex",
    "customFunction",
  ],
  components: {
    AlertDialog,
    MarketModal, //20230622 시장정의 모달 추가
    SearchContent,
  },
  setup(props) {
    //AlertDialog
    const isAlertDialogOpen = ref(false);
    const alertDialog = ref({
      maxWidthOption: "",
      title: "",
      message: "",
    });
    const closeAlertDialog = () => {
      isAlertDialogOpen.value = false;
    };

    const { t } = useI18n();
    const { parentMenuCode } = props;
    const contentsStore = useContentsStore();
    const {
      showContent,
      selectedContent,

      searchText,
      contents,
      patternContentIndex,
      patternSelected,
    } = storeToRefs(contentsStore);

    const state = reactive({
      noItemSelected: true,
    });

    const activeBookmarkTabIndex = ref(-1);

    const searchTextVal = ref(searchText);

    onMounted(() => {
      init();
    });
    watch([patternContentIndex], () => {
      init();
    });

    watch(activeBookmarkTabIndex, () => {
      if (contents.value.length > 0) {
        const groupContents = contents.value[patternContentIndex.value].groupContents;
        if (typeof groupContents !== "undefined") {
          showContent.value = groupContents[activeBookmarkTabIndex.value];
        }
      }
    });

    const init = async () => {
      activeBookmarkTabIndex.value = 0;

      const groupContents = contents.value[patternContentIndex.value].groupContents;
      if (groupContents !== undefined && groupContents.length > 0) {
        if (!groupContents.reduce((acc, cur) => acc + cur.count, 0)) {
          for (let i = groupContents.length - 1; i >= 0; i--) {
            const groupContent = groupContents[i];
            const { code, type } = groupContent;

            const _showContent = await contentsStore.onClickPatternContent2(code, type, true, patternContentIndex.value, false);
            groupContent.list = _showContent.list;
            groupContent.count = _showContent.count;
          }
        }
      } else {
        contentsStore.onClickSearchContentItem(code, type, searchTextVal.value);
      }
      
      if (groupContents !== undefined && groupContents.length > 0) {
        let isActive = false;
        for (let i = 0; i < groupContents.length; i++) {
          const groupContent = groupContents[i];
          if (!groupContent.list) groupContent.list = [];
          if (!isActive && groupContent.count > 0) {
            activeBookmarkTabIndex.value = i;
            isActive = true;
          }
        }

        showContent.value = _.clone(groupContents[activeBookmarkTabIndex.value]);
      } else {
        activeBookmarkTabIndex.value = 0;
      }
    };


    //검색
    const fnSearch = async (code, type) => {
      const commonStore = useCommonStore();
      const result = commonStore.validationSearchText(searchTextVal.value);
      if (!result) {
        alertDialog.value.message = t("message.validation_length");
        isAlertDialogOpen.value = true;
        return;
      }

      const groupContents = contents.value[patternContentIndex.value].groupContents;
      if (groupContents !== undefined && groupContents.length > 0) {
        groupContents.forEach((gc) => (gc.list = []));
        await commonStore.onPatternContentItem(groupContents, searchTextVal.value);

        for (let i = 0; i < groupContents.length; i++) {
          const groupContent = groupContents[i];
          if (groupContent.count > 0) {
            activeBookmarkTabIndex.value = i;
            break;
          }
        }

        showContent.value = _.clone(groupContents[activeBookmarkTabIndex.value]);
      } else {
        contentsStore.onClickSearchContentItem(code, type, searchTextVal.value);
      }

      return;
    };

    //검색지우기
    const fnSearchClean = async (code, type) => {
      if (typeof code === "undefined") {
        searchTextVal.value = "";
        return;
      }
      const contentsStore = useContentsStore();
      if (showContent.value.search) {
        showContent.value = {
          cont: [],
          subContents: [],
          list: [],
        };
      }
      searchTextVal.value = "";
      // await contentsStore.getPatternContents(props.parentMenuCode);
      const groupContents = contents.value[patternContentIndex.value].groupContents;
      groupContents.forEach((gc) => {
        gc.count = 0;
        gc.list.forEach(l => l.list = []);
      });
      // showContent.value = groupContents[activeBookmarkTabIndex.value];
      init();
      // contentsStore.onClickPatternContent(code, type, true, 0);
    };

    const selectedList = ref([]);
    //컨텐츠 항목별 선택시
    const onChange = (selectedList) => {
      if (selectedList.length === 0) return;

      const selected = selectedList[0];

      if (!patternSelected.value[patternContentIndex.value]) {
        patternSelected.value[patternContentIndex.value] = [];
      }

      if (!patternSelected.value[patternContentIndex.value][0]) {
        patternSelected.value[patternContentIndex.value][0] = {
          code: selected.pCode, // contentCode
          list: [],
        };
      }

      const pSelected = patternSelected.value[patternContentIndex.value][0];
      const content = contents.value[patternContentIndex.value].groupContents[activeBookmarkTabIndex.value];

      if (!patternSelected.value[props.selectedComponentIndex])
        patternSelected.value[props.selectedComponentIndex] = [];

      if (props.parentMenuCode === constants.CONSTANT_MENU_DIAGNOSIS_1_CODE) {
        //질병일 경우
        if (content.code === constants.CONSTANT_DISEASE_PATTERN_CODE) {
          if (patternSelected.value[3].length > 1) {
            const temp = [];
            temp[0] = patternSelected.value[3][0];
            if (patternSelected.value[3][1]) temp[1] = patternSelected.value[3][1];
            patternSelected.value[3] = temp;
          }
        } else {
          //질병이 아닐 경우
          if (patternSelected.value[3].length > 1) {
            const temp = [];
            temp[0] = patternSelected.value[3][0];
            if (patternSelected.value[3][2]) temp[2] = patternSelected.value[3][2];
            patternSelected.value[3] = temp;
          }
          if (!patternSelected.value[3][2]) {
            patternSelected.value[3][2] = {
              code: "C122",
              list: [ { id: "0", order: 0, name: "3단계", englishName: "Level 3", type: 0, code: "CS280" } ]
            };
          }
        }
      }

      //SOB일때, 성분/제품을 선택 할 경우 시장선택 초기화
      if (props.parentMenuCode === constants.CONSTANT_MENU_SOB_CODE) {
        if (
          constants.CONSTANT_MOLECULE_TAB_CODE.includes(content.code) ||
          content.code === constants.CONSTANT_PRODUCT_PATTERN_CODE
        ) {
          console.log(patternSelected.value[1]?.length);
          if (patternSelected.value[1]?.length > 0) {
            patternSelected.value[1][0] = null;
          }
        }
      }

      //Handling일때, 제품을 선택 할 경우 시장선택 초기화
      if ([constants.CONSTANT_MENU_SWITCHING_CODE].includes(props.parentMenuCode)) {
        if (content.code === constants.CONSTANT_PRODUCT_PATTERN_CODE) {
          console.log(patternSelected.value[1]?.length);
          if (patternSelected.value[1]?.length > 0) {
            patternSelected.value[1] = undefined;
          }
        }
      }

      pSelected.code = selected.pCode;
      pSelected.list = [ {
        ...selected, //  id, name
        type: 0, // 기본
      }];
    };

    //질병 - 측정치 문제 해결 질병 안 누르고 다른거 누르면 결과형식 날라가도록
    //선택한 항목 담기
    const onClick = () => {
      props.customFunction(patternContentIndex.value + 1);
    };

    // 20230622 시장정의 모달 추기
    const isMarketModalOpen = ref(false);
    const openMarketModal = () => {
      isMarketModalOpen.value = true;
      // contentsStore.onClickMarketContent();
    };
    const closeMarketModal = () => {
      isMarketModalOpen.value = false;
    };

    return {
      //AlertDialog
      isAlertDialogOpen,
      alertDialog,
      closeAlertDialog,
      //설정값
      constants,
      parentMenuCode,

      showContent,
      selectedContent,
      patternContentIndex,

      fnSearch,
      fnSearchClean,
      onChange,
      onClick,

      selectedList,
      searchTextVal,
      state,
      contents,
      activeBookmarkTabIndex, // 활성화된 탭의 인덱스
      patternSelected,

      isMarketModalOpen, // 20230622 시장정의 모달 추기
      openMarketModal,
      closeMarketModal,
    };
  },
});
</script>

<style scoped>
.condition {
  flex: 1 1 0;
  height: 100%;
  /* padding: 10px 0 10px 10px; */ /* 20230704 수정 */
  margin-left: 10px;
  /* border: var(--border-line); 
  border-radius: var(--border-radius); */ /* 20230704 수정 */
  transition: all 0.3s;
}
.source {
  display: none;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.source.active {
  display: flex;
}
.source-content {
  display: flex;
  width: 100%;
  height: 100%;
}
.source-content .left {
  display: flex;
  flex-direction: column;

  flex: 1 1 auto;
  height: 100%;
}
.search-bar {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}
.search-bar .search-group {
  width: 100%;
  display: flex;
}
.patternContents {
  margin-top: 10px;
}
.each-group-content-tab {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 32px;
  background-color: #fff;
  border: var(--border-line);
  border-left-width: 0;
  font-size: 15px;
  cursor: pointer;
  text-align: center;
  transition: all 0.1s ease-in;
}
.each-group-content-tab:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
}
.each-group-content-tab:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.each-group-content-tab:hover {
  background-color: #f5f5f5;
}
.active-bookmark-tab,
.active-bookmark-tab:hover {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  color: #fff;
}
.search-content {
  display: flex;
  flex: 1 1 auto;
  padding: 5px 0px;
}
.search-content-sub {
  flex: 1 1 auto;
  width: 100%;
}
.search-content-sub + .search-content-sub {
  margin-left: 5px;
}
.selected {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.selected .header {
  display: flex;
  align-items: center;
  height: fit-content;
  padding: 4px 16px;
  background-color: #f5f5f5;
  border: var(--border-line);
  border-bottom: 0;
  font-size: 15px;
  font-weight: 700;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  /* 목록 펼치고 접기 0623 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selected .header > span {
  display: inline-block;
  margin-left: 4px;
}
.selected .header > span.material-symbols-outlined {
  font-size: 26px;
  color: #b9b9b9;
}
.selected select {
  flex: 1 1 auto;
  max-width: 100%;
  width: 100%;
  padding: 12px;
  border: var(--border-line);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.selected select:focus {
  /* border: 1px solid #999; */
  outline: none;
}
.selected select option {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  padding: 4px 6px;
  margin: 1px 0;
}
.selected select option:checked {
  border-radius: 4px;
  background: #e1e8f6 linear-gradient(0deg, #e1e8f6 0%, #e1e8f6 100%);
}
/* select 선택시 라인 없애기  */
select:focus {
  outline: none;
}
/* 목록 펼치고 접기 0623 */
.listDisabled {
  width: 3%;
}
.button-wide-open {
  position: absolute;
  right: 5px;
  height: 18px;
  z-index: 10;
}
.button-wide-open .material-symbols-outlined {
  font-size: 18px;
  color: #fff;
}
.button-wide-close {
  position: absolute;
  right: 5px;
  height: 18px;
  z-index: 10;
}
.button-wide-close .material-symbols-outlined {
  font-size: 18px;
  color: #fff;
}
.content-notice {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ececec;
  border-radius: var(--border-radius);
  margin-bottom: 10px;
}
</style>
